import Model from "@/models/Model";

export default class EntryComment extends Model {
    resource() {
        return "comments";
    }

    baseURL() {
        return super.baseURL() + "/journal";
    }
}
